import { Component, Input, TemplateRef } from '@angular/core';
import { DynamicFieldModel } from '../../../index';
import { ReactiveFormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'shared-ui-dynamic-form-switch',
  imports: [ReactiveFormsModule, NgTemplateOutlet],
  template: `
    @if (template) {
      <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ fieldModel }"></ng-container>
    } @else {}
  `,
  styles: ``,
})
export class DynamicFormSwitchComponent {
  @Input() template?: TemplateRef<unknown>;
  @Input({ required: true }) fieldModel!: DynamicFieldModel;
}
